import { useContext, useState } from "react";
import { Link, NavLink as NavLinkRRD, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";
import { DocumentTypeContext } from "../../context/DocumentContext";

const Sidebar = (props: any) => {
  const { handleLogout } = useContext(AuthContext);
  const { setCollaborators, setSignersEdit } = useContext(DocumentTypeContext);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate(); 

  const toggleCollapse = () => {
    setCollapseOpen((data: any) => !data);
  };

  const closeCollapse = (name: string) => {
    if (name === "Sair") {
      handleLogout();
    }
    setCollapseOpen(false);
  };

  const createLinks = (routes: any) => {
    return routes.map((prop: any, key: number) => {
      if (prop.name === "noShow") return null;

      const isActive = location.pathname === prop.layout + prop.path;

      const handleNavigation = (name: string, path: string) => {
        if (location.pathname === "/admin/create-documents" || location.pathname === "/admin/add-signatories") {
          Swal.fire({
            title: "Você realmente quer sair?",
            text: "Se você sair, o documento não será salvo.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, sair",
            cancelButtonText: "Cancelar",
          }).then((result) => {
            if (result.isConfirmed) {
              closeCollapse(name);
              navigate(path); 
              setCollaborators([]);
              localStorage.removeItem("savedComponents");
              setSignersEdit([]);
            }
          });
        } else {
          closeCollapse(name);
          navigate(path);
        }
      };

      return (
        <NavItem key={key}>
          <NavLink
            to="#"
            tag="div" 
            onClick={() => handleNavigation(prop.name, prop.layout + prop.path)}
            style={{
              color: isActive ? "#33BBED" : "inherit",
              cursor: "pointer",
            }}
          >
            <i
              className={prop.icon}
              style={{
                color: isActive ? "#33BBED" : "gray",
              }}
            />{" "}
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };

  const { routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
            <img
              style={{ width: "176px", height: "auto"}}
              alt={logo.imgAlt}
              src={logo.imgSrc}
            />
        ) : null}

        <Collapse
          navbar
          isOpen={collapseOpen}
          style={{ margin: "0 !important" }}
        >
          <hr className="my-3" />
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <Nav navbar>{createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className="my-3" />
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
